//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/assets/css/reset.css";
import "@/assets/css/global.css";
export default {
  name: "comCheckCode",
  props: ["bindItem", "wechatFansItem", "businessUnitItem"],
  data() {
    return {
      mobile_reg: /^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/,
      codeText: "获取验证码",
      codeTimer: null
    };
  },
  created() {
    //this.bindWeChatInfo = this.$store.getters.bindWeChatInfo;
    //console.log(this.$store.getters.bindWeChatInfo);
  },
  methods: {
    getCheckCode() {
      var Mobile = this.bindItem.Mobile;
      if (!Mobile) {
        this.$msg.fail("请输入手机号");
        return;
      }
      if (!this.mobile_reg.test(Mobile)) {
        this.$msg.fail("手机号码有误");
        return;
      }
      if (this.codeText != "获取验证码") {
        this.$msg.fail("已发送验证码");
        return;
      }
      this.$msg.loading();
      this.$http({
        url: this.$api.GetSmsCheckCode,
        method: "post",
        data: {
          mobile: Mobile
        }
      })
        .then(res => {
          this.$msg.hideLoading();
          console.log("验证码", res);
          if (res.data.state == 1) {
            this.$msg.succ("验证码已发送");
            this.codeText = 120;
            this.codeTimer = setInterval(() => {
              if (this.codeText > 1) {
                this.codeText--;
              } else {
                this.codeText = "获取验证码";
                clearInterval(this.codeTimer);
                this.codeTimer = null;
              }
            }, 1000);
          } else {
            this.$msg.alert(res.data.msg);
          }
        })
        .catch((error) => {
          this.$msg.hideLoading();
          this.$msg.alert(error);
        });
    },

    startBind() {
      if (!this.bindItem.Mobile) {
        this.$msg.fail("请输入手机号");
        return;
      }
      if (!this.bindItem.SmsCheckCode) {
        this.$msg.fail("请输入验证码");
        return;
      }

      var mobile = this.bindItem.Mobile;
      var smsCheckCode = this.bindItem.SmsCheckCode;
      this.$emit("startBind", mobile, smsCheckCode);
    }
  }
};
